<template>
    <div :class="ID" class="load-hidden">
        <slot></slot>
    </div>
</template>  
<script setup lang="ts">
import { ref, onMounted, nextTick  } from 'vue';
const props = defineProps({
    options: {
        type: Object,
        default: () => ({
            // 动画的时长
            duration: 1000,
            // 延迟时间
            delay: 200,
            // 动画开始的位置，'bottom', 'left', 'top', 'right'
            origin: 'bottom',
            // 回滚的时候是否再次触发动画
            reset: false,
            // 延时执行方式（always（一直延时执行），once（只延时执行一次），onload（只在加载时延时执行））
            useDelay: 'always',
            // 在移动端是否使用动画
            mobile: true,
            // 滚动的距离，单位可以用%，rem等
            distance: '10px',
            // 其他可用的动画效果
            opacity: 0,
            // 执行速度 线性函数啥的
            easing: 'ease-in-out',
            // 执行方式（缩放）
            scale: 1
        }),
    },
    ID: {
        type: String,
        default: 'reveal',
    },
});
const { $scrollReveal } = useNuxtApp()


onMounted(async () => {
  if (!process.client) return
  await nextTick()
  if ($scrollReveal && typeof $scrollReveal.reveal === 'function') {
    $scrollReveal.reveal(`.${props.ID}`, props.options)
  }
})
const retScroll = (data: any) => {
    data.reveal(`.${props.ID}`, { ...props.options })
};


const delScroll = (data: any) => {
    data.refresh(`.${props.ID}`)
}
const handleResize = (data: any)=> {
    data.reset(`.${props.ID}`)
}
</script>
  
<style scoped>
.load-hidden {
    visibility: hidden;
}
</style>